import React from 'react';
import glodcoin from '../../../assets/icons/asset-icons/glodcoin.svg';
import silvercoin from '../../../assets/icons/asset-icons/silvercoin.svg';
import './CommonBanner.scss';

const CommonBanner = ({ className, bannerImg, title, subtitle, loadingBanner }) => {

    return (
        <>
            <section className={`quote-banner ${className || ''}`} >
                <div className="quote-banner__content">
                    <div className="quote-banner__coins left">
                        <img src={glodcoin} alt="Gold Coins" />
                    </div>
                    <div className="quote-banner__text">
                        <h3 className='big'>{title}</h3>
                        <h4>{subtitle}</h4>
                    </div>
                    <div className="quote-banner__coins right">
                        <img src={silvercoin} alt="Silver Coins" />
                    </div>
                </div>
                {/* <div className='quote-banner-mainimg'>
                    {loadingBanner ? (
                        <div className="img-shimmer" />
                    ) : (
                        <img src={bannerImg} alt="img-banner" />
                    )}
                </div> */}
            </section>
        </>
    );
};

export default CommonBanner;